export const OPPORTUNITY_PREFERENCES = [
  { key: 'paid_campaigns', label: 'Paid Brand Campaigns', icon: 'campaign' },
  { key: 'ugc', label: 'UGC', icon: 'video' },
  { key: 'gifting', label: 'Gifting / Product Seeding', icon: 'gift' },
  { key: 'events', label: 'Events & Experiences', icon: 'event' },
  { key: 'affiliate', label: 'Affiliate Partnerships', icon: 'link' },
  { key: 'brand_ambassador', label: 'Brand Ambassador / Long-term Partnerships', icon: 'handshake' },
];

export const BRAND_CATEGORY_OPTIONS = [
  ['fashion', 'Fashion'], ['beauty', 'Beauty'], ['food_beverage', 'Food & Beverage'], ['travel', 'Travel'],
  ['hospitality', 'Hospitality'], ['fitness', 'Fitness'], ['technology', 'Technology'], ['lifestyle', 'Lifestyle'],
  ['finance', 'Finance'], ['gaming', 'Gaming'], ['entertainment', 'Entertainment'], ['home', 'Home'],
  ['automotive', 'Automotive'],
].map(([key, label]) => ({ key, label }));

export const CREATOR_GOAL_OPTIONS = [
  ['first_paid_collaboration', 'Get my first paid collaboration'],
  ['more_brand_deals', 'Get more brand deals'],
  ['ugc_opportunities', 'Find UGC opportunities'],
  ['brand_discovery', 'Get discovered by brands'],
  ['professional_profile', 'Build a professional creator profile'],
  ['showcase_work', 'Showcase my work professionally'],
  ['grow_network', 'Grow my creator network'],
].map(([key, label]) => ({ key, label }));

const LABELS = Object.fromEntries(OPPORTUNITY_PREFERENCES.map(({ key, label }) => [key, label]));

export function opportunityPreferenceLabel(key) {
  if (LABELS[key]) return LABELS[key];
  return String(key || '')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function opportunityProfileCompletion(creator = {}) {
  const preferences = (creator.opportunityPreferences || []).length > 0;
  const wishlist = (creator.collaborationWishlistBrands || []).length > 0 || (creator.collaborationWishlistCategories || []).length > 0;
  const goals = (creator.creatorGoals || []).length > 0;
  const completed = [preferences, wishlist, goals].filter(Boolean).length;
  return {
    completed,
    total: 3,
    percentage: Math.round((completed / 3) * 100),
    sections: { preferences, wishlist, goals },
    isComplete: completed === 3,
  };
}
